module.exports = "/_next/static/images/tutorial_1-f11bf60fd492cb6d32930fd7723b688d.png";